var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-img',{attrs:{"src":require("@/assets/initialImage.png"),"aspect-ratio":"1.7"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }